import { render, staticRenderFns } from "./AmetrasListTableFieldTemplate.vue?vue&type=template&id=507bc4e6&scoped=true&"
import script from "./AmetrasListTableFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasListTableFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasListTableFieldTemplate.vue?vue&type=style&index=0&id=507bc4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bc4e6",
  null
  
)

export default component.exports